import { HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from 'src/app/core/api/api.service';
import { ORDER_DETAILS_ENDPOINTS } from 'src/app/core/api/endpoints/order-details.endpoints';
import { BUTTON_LOADING_ID } from 'src/app/shared/global/http-context-tokens';

@Injectable({
  providedIn: 'root'
})
export class OrderDetailsService {
  private api = inject(ApiService);

  getDirections(): Observable<any> {
    return this.api.get(ORDER_DETAILS_ENDPOINTS.V1.NEIGHBOURS_DIRECTION).pipe(
      map((data: any) => {
        return data;
      }), catchError(this.handleError)
    );
  }

  getLicenceTypes(): Observable<any> {
    return this.api.get(ORDER_DETAILS_ENDPOINTS.V1.LICENCE_TYPES).pipe(
      map((data: any) => {
        return data;
      }), catchError(this.handleError)
    );
  }


  getPropertyLocation(id): Observable<any> {
    return this.api.get(ORDER_DETAILS_ENDPOINTS.V1.ADMIN_ORDER_PROPERTY_UNIT(id)).pipe(
      map((data: any) => {
        return data;
      }), catchError(this.handleError)
    );
  }

  postPropertyLocation(id, data, buttonId = 'saveLocation'): Observable<any> {
    return this.api.post(ORDER_DETAILS_ENDPOINTS.V1.ADMIN_ORDER_PROPERTY_UNIT(id), data,
      {context: new HttpContext().set(BUTTON_LOADING_ID, buttonId)}
    )
  }

  updateBuildingSpecifications(orderId, data, buttonId?): Observable<any> {
    return this.api.put(ORDER_DETAILS_ENDPOINTS.V1.ADMIN_BUILDING_SPECIFICATIONS(orderId), data,
      {context: new HttpContext().set(BUTTON_LOADING_ID, buttonId)}
    );
  }

  updateBuildingDetails(orderId, data, buttonId?): Observable<any> {
    return this.api.put(ORDER_DETAILS_ENDPOINTS.V1.ADMIN_ORDER_BUILDING_INFO_UPDATE(orderId), data,
      {context: new HttpContext().set(BUTTON_LOADING_ID, buttonId)}
    );
  }

  updateOtherFeatures(orderId, data, buttonId?): Observable<any> {
    return this.api.put(ORDER_DETAILS_ENDPOINTS.V1.ADMIN_BUILDING_OTHER_FEATURES(orderId), data,
      {context: new HttpContext().set(BUTTON_LOADING_ID, buttonId)}
    );
  }

  getInfrastrucutreAndServices(id): Observable<any> {
    return this.api.get(
      ORDER_DETAILS_ENDPOINTS.V1.ADMIN_INFRASTRUCTURE_AND_SERVICES(id)
    );
  }

  putInfrastrucutreAndServices(id, data, buttonId?): Observable<any> {
    return this.api.put(
      ORDER_DETAILS_ENDPOINTS.V1.ADMIN_INFRASTRUCTURE_AND_SERVICES(id),
      data,
      {context: new HttpContext().set(BUTTON_LOADING_ID, buttonId)}
    );
  }

  getPropertyUnit(id: number): Observable<any> {
    return this.api.get(ORDER_DETAILS_ENDPOINTS.V2.PROPERTY_UNIT(id));
  }

  handleError(error) {
    let errorMessage;
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
